import React, { useMemo, memo } from 'react';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { Row, Col } from 'react-bootstrap';
import { tableColumns, getStillageTypeData } from 'services/stillageDashboard';
import TypeSelect from './TypeSelect';
import PropTypes from 'prop-types';
import '../../../../assets/scss/stickyTable.scss';
import '../stillages.css'
import ExportButton from 'components/common/advance-table/ExportButton';

const StillageDataTable = ({ loading, data, handleClickRow = () => null, editingTypeStillageNo = 0, onChangeType = '', hover = true }) => {
    // Amend the Type column to include the select control when editing
    const columns = useMemo(() => {
        const newCols = [...tableColumns];
        newCols[1] = {
            accessor: 'stillageType.label',
            Header: 'Type',
            isVisible: true,
            Cell: ({ row, value }) => {
                const st = row.original;
                const isEditing = editingTypeStillageNo == st.stillageNo;

                if (isEditing) {
                    const currentOption = row.original.stillageType;
                    return (<TypeSelect currentOption={currentOption} onChangeType={onChangeType} stillageNo={st.stillageNo} />);
                }

                return <span dangerouslySetInnerHTML={{ __html: value }} />
            }
        };
        return newCols;
    }, [editingTypeStillageNo]);

    const tableData = useMemo(() => getStillageTypeData(data), [data]);
    const tableProps = useMemo(() => ({
        bordered: true,
        striped: true,
        className: 'fs--1 mb-0',
        responsive: true
    }), []);

    return (
        <AdvanceTableWrapper
            columns={columns}
            data={tableData}
            sortable
            perPage={1000}
            pagination={1000}
            globalFilterColumns={["stillageNo", "custName"]}
        >
            <Row className="justify-content-between mb-3 mt-1">
                <Col xs="auto">
                    <ExportButton table />
                </Col>
                <Col xs="auto">
                    <AdvanceTableSearchBox table placeholder='Search name or no.' />
                </Col>
            </Row>
            <div className="sticky-zone-stillages">
                <AdvanceTable
                    table
                    headerClassName="bg-200 text-nowrap align-middle sticky-header-stillages"
                    rowClassName={`align-middle white-space-nowrap ${hover ? 'hover-row' : ''}`}
                    tableProps={tableProps}
                    loading={loading}
                    handleClickRow={handleClickRow}
                />
            </div>
        </AdvanceTableWrapper>
    )
}

StillageDataTable.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    handleClickRow: PropTypes.func,
    editingTypeStillageNo: PropTypes.number,
    onChangeType: PropTypes.func,
    row: PropTypes.object,
    value: PropTypes.string,
    hover: PropTypes.bool
};

export default memo(StillageDataTable);